import './QuoteDetailHeaderSkeleton.scss';

/** Skeleton de carga para el encabezado de detalle de cotización */
const QuoteDetailHeaderSkeleton = () => {
  const clientInfoWidths = [145, 200, 200, 200];

  return (
    <div className="quoteDetailHeaderSkeleton">
      <div className="topRow">
        <div className="topLeft">
          <div className="quoteNumber">
            <div className="titleSkeleton animationLoader" />
            <div className="statusSkeleton animationLoader" />
          </div>
          <div className="badges">
            <div className="badgeSkeleton animationLoader" />
            <div className="badgeSkeleton animationLoader" />
          </div>
        </div>
        <div className="lastUpdateCard">
          <div className="lastUpdateLeft">
            <div className="iconBoxSkeleton animationLoader" />
            <div className="lastUpdateLines">
              <div className="lineSkeleton short animationLoader" />
              <div className="lineSkeleton medium animationLoader" />
              <div className="lineSkeleton short animationLoader" />
            </div>
          </div>
          <div className="historyBtnSkeleton animationLoader" />
        </div>
      </div>
      <div className="divider" />
      <div className="downRow">
        <div className="downRowLeft">
          <div className="avatarSkeleton animationLoader" />
          <div className="clientInfoList">
            {clientInfoWidths.map((width, i) => (
              <div key={i} className="clientInfoItem" style={{ width: `${width / 10}rem` }}>
                <div className="labelSkeleton animationLoader" />
                <div className="valueSkeleton animationLoader" />
              </div>
            ))}
          </div>
        </div>
        <div className="responsiblesBtnSkeleton animationLoader" />
      </div>
    </div>
  );
};

export default QuoteDetailHeaderSkeleton;
